function toNumber(value, fallback) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

const PRICE_RANGE_OPTIONS = [
  { label: "Under 100", min: 0, max: 100 },
  { label: "100-500", min: 100, max: 500 },
  { label: "500-1000", min: 500, max: 1000 },
  { label: "1000-2500", min: 1000, max: 2500 },
  { label: "2500+", min: 2500, max: "" },
];

export default function PickSettingsPanel({ pickSettings = {}, onChange, onReload, reloading = false }) {
  const priceMin = toNumber(pickSettings.priceMin, null);
  const priceMax = toNumber(pickSettings.priceMax, null);

  const updateValue = (name, value) => {
    onChange((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const applyPriceRange = (range) => {
    const nextSettings = {
      ...pickSettings,
      priceMin: range.min,
      priceMax: range.max,
    };
    onChange(nextSettings);
    onReload?.(nextSettings);
  };

  const isActiveRange = (range) => {
    const currentMin = priceMin === null ? "" : priceMin;
    const currentMax = priceMax === null ? "" : priceMax;
    return currentMin === range.min && currentMax === range.max;
  };

  return (
    <section className="pick-settings-panel">
      <div className="signal-panel-header">
        <div>
          <h2>Stock Price Filter</h2>
          <p>Use this to restrict strategy picks to stocks that fit your investment amount.</p>
        </div>
        <span className="effective-price">Max price: {priceMax ?? "All"}</span>
      </div>

      <div className="pick-settings-toolbar">
        <div className="quick-price-row backend-price-row" aria-label="Backend stock price ranges">
          {PRICE_RANGE_OPTIONS.map((range) => (
            <button
              className={isActiveRange(range) ? "active" : ""}
              key={range.label}
              type="button"
              onClick={() => applyPriceRange(range)}
              disabled={reloading}
            >
              {range.label}
            </button>
          ))}
        </div>

        <div className="guide-settings-grid pick-settings-controls">
          <label>
            <span>Price From</span>
            <input
              className="guide-input guide-price-input"
              min="0"
              step="0.01"
              type="number"
              value={pickSettings.priceMin ?? ""}
              onChange={(event) => updateValue("priceMin", event.target.value)}
            />
          </label>
          <label>
            <span>Price To</span>
            <input
              className="guide-input guide-price-input"
              min="0"
              step="0.01"
              type="number"
              value={pickSettings.priceMax ?? ""}
              onChange={(event) => updateValue("priceMax", event.target.value)}
            />
          </label>
          <button
            className="refresh-btn pick-settings-reload"
            type="button"
            onClick={() => onReload?.()}
            disabled={reloading}
          >
            {reloading ? "Reloading..." : "Reload Opportunities"}
          </button>
        </div>
      </div>
    </section>
  );
}
